import { render, staticRenderFns } from "./MarqetaBusinessCreation.vue?vue&type=template&id=593a908f&scoped=true"
import script from "./MarqetaBusinessCreation.vue?vue&type=script&lang=js"
export * from "./MarqetaBusinessCreation.vue?vue&type=script&lang=js"
import style0 from "./MarqetaBusinessCreation.vue?vue&type=style&index=0&id=593a908f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a908f",
  null
  
)

export default component.exports